<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
  
          <div class="modal-header">
            <h5 class="modal-title text-success">
              <font-awesome-icon icon="dollar-sign" class="me-2" />
              Actualizar Precio Unitario
            </h5>
            <button type="button" class="btn-close" @click="$emit('cancelar')"></button>
          </div>
  
          <div class="modal-body">
            <div class="mb-3">
              <label>Nuevo Precio Unitario ({{ monedaActual.codigo }})</label>
              <input v-model.number="precio_unitario" type="number" min="0" step="0.01" class="form-control" placeholder="Ej: 10.50">
            </div>
  
            <div class="mb-3">
              <label>Moneda</label>
              <input type="text" class="form-control" :value="monedaActual.codigo" readonly>
            </div>
          </div>
  
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="$emit('cancelar')">Cancelar</button>
            <button type="button" class="btn btn-success" @click="actualizarPrecio">Actualizar Precio</button>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    name: "ModalActualizarPrecioProductoEnvasado",
    props: {
      envasado: { type: Object, required: true }
    },
    data() {
      return {
        precio_unitario: this.envasado.precio_unitario || 0,
        monedaActual: {},
        clubActual: this.$store.getters.getClubActual
      };
    },
    methods: {
      async fetchMoneda() {
        try {
          const res = await axios.get("/api/moneda_actual", {
            params: { club_id: this.clubActual.id }
          });
          this.monedaActual = res.data;
        } catch (error) {
          console.error("Error al obtener moneda actual:", error);
        }
      },
      async actualizarPrecio() {
        try {
          await axios.put(`/api/producto_final_envasado_precio/${this.envasado.id}`, {
            precio_unitario: this.precio_unitario,
            tipo_moneda: this.monedaActual.codigo
          });
  
          this.$emit('precioActualizado', {
            ...this.envasado,
            precio_unitario: this.precio_unitario,
            tipo_moneda: this.monedaActual.codigo
          });
  
        } catch (error) {
          console.error("Error al actualizar precio:", error);
          alert("Error al actualizar el precio.");
        }
      }
    },
    mounted() {
      this.fetchMoneda();
    }
  };
  </script>
  
  <style scoped>
  .modal {
    background-color: rgba(0,0,0,0.5);
  }
  
  .modal-content {
    border-radius: 10px;
  }
  
  .modal-body label {
    font-weight: 600;
  }
  </style>
  